import React, { useRef, useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';
import CommonBubble from '@home/components/CommonBubble';
import { IOverflowBubbleTextProps } from '@/pages/dashboard/components/OverflowBubbleText/type';
import './index.scss';

export const OverflowBubbleText: React.FC<IOverflowBubbleTextProps> = ({
  text,
  className,
  placement = 'right',
  dark = true,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const rafRef = useRef<number>(0);
  const [isOverflow, setIsOverflow] = useState(false);

  const checkOverflow = useCallback(() => {
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      const element = textRef.current;
      if (element) {
        setIsOverflow(element.scrollWidth > element.clientWidth);
      }
    });
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [text, checkOverflow]);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(rafRef.current);
    };
  }, [checkOverflow]);

  const textElement = (
    <span className={classNames('dbd-overflow-bubble-text', className)} ref={textRef}>
      {text}
    </span>
  );

  if (isOverflow) {
    return (
      <CommonBubble content={text} placement={placement} dark={dark}>
        {textElement}
      </CommonBubble>
    );
  }

  return textElement;
};
